import { render, staticRenderFns } from "./UserCreated.vue?vue&type=template&id=6018e84f&scoped=true"
import script from "./UserCreated.vue?vue&type=script&lang=js"
export * from "./UserCreated.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/clientPage.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UserCreated.vue?vue&type=style&index=1&id=6018e84f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6018e84f",
  null
  
)

export default component.exports